var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 73.3333C58.4095 73.3333 73.3333 58.4095 73.3333 40C73.3333 21.5905 58.4095 6.66666 40 6.66666C21.5905 6.66666 6.66663 21.5905 6.66663 40C6.66663 58.4095 21.5905 73.3333 40 73.3333Z",
    fill: "#0E9658"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.16663 40C4.16663 20.2098 20.2097 4.16666 40 4.16666C59.7902 4.16666 75.8333 20.2098 75.8333 40C75.8333 59.7902 59.7902 75.8333 40 75.8333C20.2097 75.8333 4.16663 59.7902 4.16663 40ZM40 9.16666C22.9712 9.16666 9.16663 22.9712 9.16663 40C9.16663 57.0288 22.9712 70.8333 40 70.8333C57.0288 70.8333 70.8333 57.0288 70.8333 40C70.8333 22.9712 57.0288 9.16666 40 9.16666Z",
    fill: "#0E9658"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40 24.1667C41.3807 24.1667 42.5 25.2859 42.5 26.6667V53.3333C42.5 54.714 41.3807 55.8333 40 55.8333C38.6193 55.8333 37.5 54.714 37.5 53.3333V26.6667C37.5 25.2859 38.6193 24.1667 40 24.1667Z",
    fill: "#FFFBFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.1666 40C24.1666 38.6193 25.2859 37.5 26.6666 37.5H53.3333C54.714 37.5 55.8333 38.6193 55.8333 40C55.8333 41.3807 54.714 42.5 53.3333 42.5H26.6666C25.2859 42.5 24.1666 41.3807 24.1666 40Z",
    fill: "#FFFBFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.90aafb32aa0a4b75c6d117670d4d5e10.svg";
export { ForwardRef as ReactComponent };